import React, { ChangeEvent } from "react";
import { List, RowComponentProps } from "react-window";

const ITEM_HEIGHT = 42;

function RowComponent({
    index,
    filteredOptions,
    selectedTags,
    handleCheck,
    style,
}: RowComponentProps<{
    filteredOptions: string[],
    selectedTags: string[],
    handleCheck: (e: ChangeEvent<HTMLInputElement>) => void,
}>) {
    const option = filteredOptions[index];
    const checked = selectedTags.includes(option);

    return (
        <label 
            style={style}
            htmlFor={`${option}_${index}`} 
            className={`${checked ? 'bg-secondary text-primary hover:bg-opacity-1' : 
            'bg-none text-default hover:bg-opacity-[0.5]'} 
            hover:cursor-pointer hover:text-primary hover:bg-secondary text-left font-medium flex justify-start items-center gap-3 px-4 py-3 w-full`}
        >
            <input 
                id={`${option}_${index}`} 
                type='checkbox' 
                onChange={handleCheck} 
                checked={checked} 
                className='accent-primary'
                name={option}
            />
            <p className='text-nowrap text-[14px]'>{option}</p>
        </label>
    )
}

export default function TagsFixedList({
    filteredOptions,
    selectedTags,
    handleCheck,
}: {
    filteredOptions: string[];
    selectedTags: string[];
    handleCheck: (e: ChangeEvent<HTMLInputElement>) => void,
}) {

    return (
        <div className="h-[300px]">
            <List
                rowComponent={RowComponent}
                rowCount={filteredOptions.length}
                rowHeight={ITEM_HEIGHT}
                rowProps={{
                    filteredOptions,
                    selectedTags,
                    handleCheck,
                }}
            />
        </div>
    )
}